/**
 * @param reference : id of the item
 * @param resourceType : resource in which the item belongs to
 * @param subResourceType : subResourceType in which the item belongs to
 * @class Authorization
 */
export class Authorization {
  reference;
  resourceType;
  subResourceType;

  constructor(reference: string,
              resourceType: string,
              subResourceType: ISubResourceType = null) {
    this.reference = reference;
    this.resourceType = resourceType;
    this.subResourceType = subResourceType;
  }
}

export interface ISubResourceType {
  code: string;
  display: string;
}
